import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MediaComponent } from '@shared/components/media/media.component';
import { ResponsiveCategoryGrid } from '@core/models/atomics.model';
import { DeviceService } from '@shared/tools/device.service';
import { CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';

@Component({
  selector: 'cx-grid-categories',
  templateUrl: './cx-grid-categories.component.html',
  styleUrl: './cx-grid-categories.component.scss',
  imports: [CommonModule, RouterModule, MediaComponent],
})
export class CxGridCategoriesComponent {
  protected gridCategories = inject<ResponsiveCategoryGrid>(CX_ABSTRACT_COMPONENT_DATA);
  protected deviceService = inject(DeviceService);
  protected currentDeviceSize = this.deviceService.getCurrentSize();
}
